import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { UserRoleMappingComponent } from './phases/user-role-mapping/user-role-mapping.component';
import { DepartmentRoleMappingComponent } from './phases/department-role-mapping/department-role-mapping.component';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    UserRoleMappingComponent,
    DepartmentRoleMappingComponent
  ]
})
export class AssignmentComponent {

  @ViewChild(UserRoleMappingComponent) userRoleMappingComponent!: UserRoleMappingComponent;
  @ViewChild(DepartmentRoleMappingComponent) departmentRoleMappingComponent!: DepartmentRoleMappingComponent;

  phaseIndex = 0;

  phaseChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.phaseIndex = tabChangeEvent.index;
  }

  get loading(): BehaviorSubject<boolean> {
    return this.phaseIndex === 1
      ? this.departmentRoleMappingComponent?.loading ?? new BehaviorSubject<boolean>(false)
      : this.userRoleMappingComponent?.loading ?? new BehaviorSubject<boolean>(false);
  }

  get saving(): BehaviorSubject<boolean> {
    return this.phaseIndex === 1
      ? this.departmentRoleMappingComponent?.saving ?? new BehaviorSubject<boolean>(false)
      : this.userRoleMappingComponent?.saving ?? new BehaviorSubject<boolean>(false);
  }

  async onSaveClick(): Promise<void> {
    if (this.phaseIndex === 1) {
      await this.departmentRoleMappingComponent.onSaveClick();
    } else {
      await this.userRoleMappingComponent.onSaveClick();
    }
  }

  loadPage(): void {
    this.userRoleMappingComponent?.loadPage();
    this.departmentRoleMappingComponent?.loadPage();
  }
}
